<template>
  <LoadingSpinner v-if="loading" />
  <PostSigning
    v-else
    :branding="blankBranding"
    :heading="$t('widgetSigned.needToVerify')"
    :messageIntro="$t('widgetSigned.needToVerifyMessageIntro')"
    :message="$t('widgetSigned.needToVerifyMessage')"
    type="warning"
  />
</template>

<script setup>
// @ts-check
import { computed, defineProps } from 'vue'
import { useSignedData } from '@/composables/useSignedData'

import PostSigning from '@/components/screens/PostSigningScreen.vue'
import LoadingSpinner from '@/components/LoadingSpinner.vue'

const props = defineProps({
  widgetCode: {
    type: String,
    required: true
  }
})

const { branding, loading } = useSignedData({ widgetCode: props.widgetCode })
// disable branding until widget data moved to v2
const blankBranding = computed(() => {
  if (branding.value) {
    return {
      title: '',
      colours: {},
      logo: ''
    }
  }

  return undefined
})
</script>
